import React from 'react';

const SVG = ({
  style = {},
  fill = '#000',
  viewBox = '0 0 24 17.76',
  width = '100%',
  className = '',
  height = '100%',
  ...rest
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox={viewBox}
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...rest}
  >
    <g id="home-outline" transform="translate(0 -4.137)">
      <g fill="none" fillRule="evenodd">
        <path
          stroke="none"
          d="M3.787 11.413v6.347h6.026v-5.067h4.373v5.067h6.027v-6.347H24L12 0 0 11.413z"
          transform="translate(0 4.137)"
        />
        <path
          stroke="none"
          d="M19.213 16.76v-6.347h2.285L12 1.38l-9.498 9.033h2.285v6.347h4.026v-5.067h6.374v5.067h4.026m1 1h-6.026v-5.067H9.813v5.067H3.787v-6.347H0L12 0l12 11.413h-3.787v6.347z"
          fill={fill}
          transform="translate(0 4.137)"
        />
      </g>
    </g>
  </svg>
);
export default SVG;
